/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Tooltip1Inputs */

const id_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar ini adalah perubahan yang dibuat pada penawaran khusus ini atau item, asset, atau build terkait.`)
};

const ms_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai ini adalah perubahan yang dibuat pada tawaran khusus ini atau item, aset, atau binaan yang berkaitan.`)
};

const da_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne liste viser ændringerne foretaget til dette specifikke tilbud eller relaterede items, assets eller builds.`)
};

const de_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Liste zeigt die Änderungen an diesem spezifischen Angebot oder zugehörigen Items, Assets oder Builds.`)
};

const en_us2_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This list are the changes made to this specific offer or related items, assets or builds.`)
};

const es_es2_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista muestra los cambios realizados a esta oferta de catálogo específica o a sus ítems, assets o compilaciones relacionadas.`)
};

const es_mx2_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista muestra los cambios realizados a esta oferta específica o a sus ítems, assets o compilaciones relacionadas.`)
};

const fil_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang listahang ito ay ang mga pagbabagong ginawa sa partikular na offer na ito o mga kaugnay na item, asset o build.`)
};

const fr_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette liste présente les modifications apportées à cette offre de catalogue spécifique ou à ses items, assets ou compilations associés.`)
};

const it_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo elenco mostra le modifiche apportate a questa specifica offerta o agli articoli, asset o build correlati.`)
};

const hu_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a lista az ehhez az ajánlathoz vagy kapcsolódó elemekhez, asset-ekhez vagy build-ekhez végrehajtott változtatásokat tartalmazza.`)
};

const nl_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze lijst bevat de wijzigingen die zijn aangebracht aan dit specifieke aanbod of gerelateerde items, assets of builds.`)
};

const no_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne listen er endringene som er gjort på dette spesifikke tilbudet eller relaterte elementer, eiendeler eller builds.`)
};

const pl_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta lista przedstawia zmiany wprowadzone w tej konkretnej ofercie lub powiązanych elementach, assetach lub kompilacjach.`)
};

const pt_br2_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista mostra as alterações feitas nesta oferta de catálogo específica ou em seus itens, assets ou builds relacionados.`)
};

const pt_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista mostra as alterações feitas a esta oferta específica ou a itens, assets ou compilações relacionadas.`)
};

const ro_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această listă prezintă modificările făcute acestei oferte specifice sau elementelor, asset-urilor sau compilărilor conexe.`)
};

const fi_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä lista näyttää tähän tarjoukseen tai liittyviin kohteisiin, resursseihin tai koontiversioihin tehdyt muutokset.`)
};

const sv_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna lista visar ändringarna som gjorts i detta specifika erbjudande eller relaterade objekt, tillgångar eller byggen.`)
};

const vi_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách này là các thay đổi được thực hiện đối với ưu đãi cụ thể này hoặc các mục, asset hoặc bản dựng liên quan.`)
};

const tr_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu liste, bu belirli teklifte veya ilgili öğelerde, assetlerde veya yapılarda yapılan değişikliklerdir.`)
};

const cs_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento seznam obsahuje změny provedené v této konkrétní nabídce nebo souvisejících položkách, assetech nebo sestaveních.`)
};

const bg_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този списък показва промените, направени в тази конкретна оферта или свързаните обекти, активи или компилации.`)
};

const ru_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот список содержит изменения, внесённые в данное конкретное предложение или связанные с ним объекты, ассеты или сборки.`)
};

const uk_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей список містить зміни, внесені до цієї пропозиції або пов'язаних з нею елементів, асетів чи збірок.`)
};

const ar_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذه القائمة هي التغييرات التي تم إجراؤها على هذا العرض أو العناصر أو الأصول أو البنيات ذات الصلة.`)
};

const hi_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह सूची इस विशिष्ट ऑफ़र या संबंधित आइटम, एसेट या बिल्ड में किए गए परिवर्तन हैं।`)
};

const th_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการนี้คือการเปลี่ยนแปลงที่ทำกับข้อเสนอหรือรายการ แอสเซท หรือบิลด์ที่เกี่ยวข้อง`)
};

const ja_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリストは、この特定のオファーまたは関連するアイテム、アセット、ビルドに加えられた変更です。`)
};

const zh_cn2_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此列表显示了对此特定目录项或相关物品、资源或构建版本所做的更改。`)
};

const zh_hant1_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此清單顯示了對此特定目錄項目或相關物品、資源或建置版本所做的變更。`)
};

const ko_offerdetail_changelog_tooltip1 = /** @type {(inputs: Offerdetail_Changelog_Tooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 목록은 이 특정 오퍼 또는 관련 아이템, 에셋, 빌드에 대한 변경 사항입니다.`)
};

/**
* | output |
* | --- |
* | "This list are the changes made to this specific offer or related items, assets or builds." |
*
* @param {Offerdetail_Changelog_Tooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_tooltip1 = /** @type {((inputs?: Offerdetail_Changelog_Tooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Tooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_tooltip1(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_tooltip1(inputs)
	if (locale === "da") return da_offerdetail_changelog_tooltip1(inputs)
	if (locale === "de") return de_offerdetail_changelog_tooltip1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_tooltip1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_tooltip1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_tooltip1(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_tooltip1(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_tooltip1(inputs)
	if (locale === "it") return it_offerdetail_changelog_tooltip1(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_tooltip1(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_tooltip1(inputs)
	if (locale === "no") return no_offerdetail_changelog_tooltip1(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_tooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_tooltip1(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_tooltip1(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_tooltip1(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_tooltip1(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_tooltip1(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_tooltip1(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_tooltip1(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_tooltip1(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_tooltip1(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_tooltip1(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_tooltip1(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_tooltip1(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_tooltip1(inputs)
	if (locale === "th") return th_offerdetail_changelog_tooltip1(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_tooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_tooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_tooltip1(inputs)
	return ko_offerdetail_changelog_tooltip1(inputs)
});
export { offerdetail_changelog_tooltip1 as "offerDetail.changelog.tooltip" }